"use client";

import { routes } from "@/utils/routes";
import { Button } from "antd";
import Link from "next/link";
import { Result } from "antd";
import { useEffect } from "react";

export default function Error({ error, reset }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="font-bold h-screen flex items-center justify-center">
      <Result
        status="500"
        title="500"
        subTitle={error.message || "Xin lỗi, có lỗi xảy ra!!!"}
        extra={
          <Link href={routes.home}>
            <Button type="primary">Trở về trang chủ</Button>
          </Link>
        }
      />
    </div>
  );
}
